// User roles and where each role may go. The backend is the source of truth for
// a user's role and must enforce every permission; these checks only shape the UI.

export const ROLES = Object.freeze({
  SENDER: 'sender',
  TRAVELLER: 'traveller',
  ADMIN: 'admin',
});

export const ROLE_LABELS = Object.freeze({
  [ROLES.SENDER]: 'Sender',
  [ROLES.TRAVELLER]: 'Traveller',
  [ROLES.ADMIN]: 'Admin',
});

// Portal root for each role.
export const ROLE_HOME = Object.freeze({
  [ROLES.SENDER]: '/sender',
  [ROLES.TRAVELLER]: '/traveller',
  [ROLES.ADMIN]: '/admin',
});

// Roles a person may choose when signing up. Admins are created by other admins only.
export const SELF_SIGNUP_ROLES = Object.freeze([ROLES.SENDER, ROLES.TRAVELLER]);

export const isValidRole = (role) => Object.values(ROLES).includes(role);

export const homeFor = (role) => ROLE_HOME[role] || '/';

// Which role owns a path, e.g. '/sender/requests' → 'sender'. Public paths return null.
export const roleForPath = (path = '') => {
  const first = path.split(/[?#]/)[0].split('/')[1];
  return Object.values(ROLES).includes(first) ? first : null;
};

// Only allow redirects to same-site paths the role can open (prevents open redirects).
export function safeRedirect(target, role) {
  if (typeof target !== 'string' || !target.startsWith('/') || target.startsWith('//') || target.includes('\\')) return homeFor(role);
  if (/^\/(login|register|forgot-password)\b/.test(target)) return homeFor(role);
  const owner = roleForPath(target);
  return owner && owner !== role ? homeFor(role) : target;
}
